import { Component } from 'react'
import { RewardsFilter } from 'interfaces/bounty'
import * as cn from 'classnames'
import * as styles from 'components/features/pfm/RewardDetailsTabs/RewardDetailsTabsMobile.css'
import { OverlayMobile } from 'components/features/pfm/Overlay/OverlayMobile'
import { REWARD_FILTERS } from 'constants/bounty'
import * as capitalize from 'lodash/capitalize'
import { PopupTitle } from 'components/atoms/Text'
import { RewardDetailsTabsProps } from 'components/features/pfm/RewardDetailsTabs/RewardDetailsTabs'

type RewardDetailsTabsMobileState = {
  isOpened: boolean
}

class RewardDetailsTabsMobile extends Component<RewardDetailsTabsProps, RewardDetailsTabsMobileState> {
  state = {
    isOpened: false,
  }

  render () {
    const { isOpened } = this.state

    return (
      <>
        { this.renderToggle() }
        { isOpened && this.renderOpen() }
      </>
    )
  }

  renderTab = (filter: RewardsFilter) => {
    const { active } = this.props
    const isActive = active === filter

    const onClick = isActive
      ? undefined
      : () => this.handleTabClick(filter)

    const className = cn(styles.option, {
      [styles.active]: isActive,
    })

    return (
      <div
        className={ className }
        key={ filter }
        data-qa-marker={ filter }
        data-qa-type='tab'
        onClick={ onClick }
      >
        { filter }
      </div>
    )
  }

  renderToggle () {
    const { active } = this.props
    const copy = `${ capitalize(active) } Rewards`

    return (
      <div className={ styles.toggle } onClick={ this.toggleOpen }>
        { copy }
        <div className={ styles.arrow } />
      </div>
    )
  }

  renderOpen () {
    return (
      <OverlayMobile onClose={ this.toggleOpen }>
        <div className={ styles.popupTitleWrapper }>
          <PopupTitle>
            Select Rewards Status
          </PopupTitle>
        </div>
        { REWARD_FILTERS.map(this.renderTab) }
      </OverlayMobile>
    )
  }

  private toggleOpen = () => {
    this.setState({
      isOpened: !this.state.isOpened,
    })
  }

  private handleTabClick = (filter: RewardsFilter) => {
    this.props.onTabClick(filter)
    this.toggleOpen()
  }
}

export default RewardDetailsTabsMobile
